import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
// import counter from './counter';
import account from './account';
import stores from './stores';
import categories from './categories';
import kiosks from './kiosks';
import amenities from './amenities';
import floorplans from './floorplans';
import checkpoints from './checkpoints';
import tags from './tags';
import users from './users';
import medias from './medias';
import events from './events';

export default combineReducers({
  router: routerReducer,
  // counter,
  account,
  stores,
  categories,
  kiosks,
  amenities,
  floorplans,
  checkpoints,
  tags,
  users,
  medias,
  events,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js